import UnitsForm from '@/view/forms/units-form'
import { List, PlusCircle } from 'lucide-react'
import { useState } from 'react'
import { Tabs, TabsList, TabsTrigger } from '../../components/ui/tabs'
import { DisplayUnits } from './panels/display-units'

interface IUnitsPage {}

export default function UnitsPage(props: IUnitsPage) {
  console.log(props)

  const [tab, setTab] = useState('units')

  return (
    <div className="w-full">
      <main className="flex flex-col gap-6">
        <div className="w-full overflow-y-scrol flex justify-between">
          <Tabs defaultValue="units" className="w-[320px]" onValueChange={setTab}>
            <TabsList>
              <TabsTrigger value="units" className="data-[state=active]:bg-acelerafit-green-400 data-[state=active]:text-muted flex gap-2">
                <List className="text-sm" />
                Unidades
              </TabsTrigger>
              <TabsTrigger value="register-units" className="data-[state=active]:bg-acelerafit-green-400 data-[state=active]:text-muted flex gap-2">
                <PlusCircle className="text-sm" />
                Cadastrar Unidade
              </TabsTrigger>
            </TabsList>
          </Tabs>

          <div className="flex gap-2">
            {/* <Button className="text-acelerait-black flex gap-2 text-sm" variant="outline">
              <ListFilter />
              Filtro
            </Button> */}
          </div>
        </div>
        <div className="flex flex-col gap-4 border-acelerafit-gray-white rounded-md border p-6">
          {tab == 'units' && (
            <>
              <header>
                <h3 className="text-acelerait-black text-2xl font-bold">Unidades</h3>
                <p className="text-sm text-acelerafit-gray-dark">Gerencie e acompanhe o cadastro, status e informações das Unidades.</p>
              </header>
              <div className="h-container-members overflow-hidden">
                <DisplayUnits />
              </div>
            </>
          )}

          {tab == 'register-units' && (
            <>
              <header>
                <h3 className="text-acelerait-black text-2xl font-bold">Adicionar Unidade</h3>
                <p className="text-sm text-acelerafit-gray-dark">Preencha as informações abaixo para registrar uma nova Unidade.</p>
              </header>
              <UnitsForm />
            </>
          )}
        </div>
      </main>
    </div>
  )
}
